<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <datatable
        :total="feedbacks.meta.page.total"
        :perPage="feedbacks.meta.page.perPage"
        :currentPage="feedbacks.meta.page.currentPage"
        :columns="[
          { id: 'office_code', name: 'Mitra Usaha' },
          { id: 'date', name: 'Tanggal' },
          { id: 'message', name: 'Saran' },
        ]"
        @pagechanged="onPageChange"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="feedback in feedbacks.data"
            :key="feedback.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">{{ feedback.attributes.office_code ?? '-' }}</td>
            <td :class="classes.td">{{ feedback.attributes.createdAt | formatDate }}</td>
            <td :class="classes.td">{{ feedback.attributes.message ?? '-' }}</td>
          </tr>
        </template>
      </datatable>
    </div>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';

export default {
  name: 'Home',
  mixins: [requestMixin],
  components: {
  },
  data() {
    return {
      loading: false,
      feedbacks: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  created() {
    this.loadFeedbacks();
  },
  methods: {
    onPageChange(page) {
      this.loadFeedbacks({
        'page[number]': page
      });
    },
    async loadFeedbacks(params) {
      this.loading = true;

      const [res, err] = await this.request('/api/v1/feedback', {
        params: {
          'page[size]': 5,
          'sort': '-id',
          ...params,
        },
      });

      if (!err) {
        this.feedbacks = res;
      }

      this.loading = false;
    },
  },
};
</script>
